angular.module('apple-pay', [])
    .service('ApplePay', ApplePay);

ApplePay.$inject = ['$state', 'configs', '$rootScope', '$timeout', 'PortalApi', 'Authentication', '$stateParams', 'uibDatepickerConfig', '$location', '$translate', 'Notification', 'Analytics', 'ClientCards', 'DateFormater', '$anchorScroll', 'Localization'];

function ApplePay($state, configs, $rootScope, $timeout, PortalApi, Authentication, $stateParams, uibDatepickerConfig, $location, $translate, Notification, Analytics, ClientCards, DateFormater, $anchorScroll, Localization) {

    var applepay = {
        data: {

        },
    };

    return applepay;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/apple-pay/services/apple-pay.js
 ** module id = 71
 ** module chunks = 1
 **/